import React, { useEffect, useState } from "react";
import {
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Tooltip,
  Typography
} from "@material-ui/core";
import NoteAddIcon from '@material-ui/icons/NoteAdd';
import { useDispatch, useSelector } from "react-redux";
import { AUTORIZACIONES_PRESUPUESTOS_ESTADOS, TIPO_CERTIFICADOS } from "../../../../utils/constants";
import CarritoCertificados from "../../../Discapacidad/Home/components/CarritoCertificados";
import { fetchRecuperoSolicitud } from "../../../../actions/autorizaciones/abmRecupero";
import { fetchEmpadronamientoSolicitud, getDatosAfiliadosRecuperoAutorizador, getPracticasSolicitudSeleccionada } from "../../../../actions/autorizaciones/Autorizaciones";
import { fetchCertificados } from "../../../../actions/certificados";
import ModalHistorialAllConsumos from "../../../compartidos/historialConsumos/ModalHistorialAllConsumos";
import moment from "moment";
import "moment/locale/es";
import { LocalHospitalSharp } from "@material-ui/icons";
import { generatePDFHceAfiliado } from "../../../../actions/hce/hceActions";

const optionsfecha = {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
};

export const AfiliadoMenu = ({ afiliado, integracion = false, solicitud = false, idMotivoInternacion, presupuestoSeleccionado = false, desdeBandejaRecupero = false }) => {
  const dispatch = useDispatch();
  const { items: itemsCertificados } = useSelector((state) => state.certificadosAfiliacion);
  const { solicitudSeleccionada = {}, empadronamientoSolicitud, afiliadosRecupero } = useSelector(
    (state) => state.autorizaciones
  );

  const [edadAfiliado, setEdadAfiliado] = useState(0);
  const [openModalConsumos, setOpenModalConsumos] =
    useState(false);
  const [certificadoVigente, setCertificadoVigente] = useState({});

  useEffect(() => {
    setEdadAfiliado(
      moment().diff(moment(afiliado?.fecha_nacimiento), "years", false)
    );
  }, [afiliado]);

  useEffect(() => {
    if (afiliado) {
      dispatch(fetchCertificados(afiliado?.id_afiliado, null));
    }
  }, [dispatch, afiliado?.id_afiliado]);

  useEffect(() => {
    if (solicitud && solicitudSeleccionada?.idSolicitud) {
      dispatch(fetchRecuperoSolicitud(solicitudSeleccionada?.idSolicitud));
      dispatch(fetchEmpadronamientoSolicitud(solicitudSeleccionada?.idSolicitud));
      dispatch(getDatosAfiliadosRecuperoAutorizador(solicitudSeleccionada?.idAfiliado))
    }
  }, [dispatch, solicitud, solicitudSeleccionada?.idSolicitud]);

  useEffect(() => {
    if (solicitudSeleccionada?.idSolicitud && !presupuestoSeleccionado) {
      dispatch(getPracticasSolicitudSeleccionada(solicitudSeleccionada?.idSolicitud));
    }
  }, [dispatch, solicitudSeleccionada?.idSolicitud]);

  const impresionHCE = () => {
    dispatch(generatePDFHceAfiliado(afiliado?.id_afiliado, null, true, false));
  }

  return (
    <React.Fragment>
      <Typography
        variant="h6"
        style={{
          textDecoration: "underline",
          textAlign: "center",
          margin: "1.5rem 0",
        }}
      >
        Información Afiliado
        {
          <Tooltip title="Consumos">
            <Button
              style={{ marginTop: -5, marginLeft: 25 }}
              onClick={() => setOpenModalConsumos(true)}
            >
              <NoteAddIcon fontSize="large" />
            </Button>
          </Tooltip>
        }
        {
          <Tooltip title="Historia Clínica">
            <Button
              style={{ marginTop: -5, marginLeft: 10 }}
              onClick={() => impresionHCE()}
            >
              <LocalHospitalSharp fontSize="large" />
            </Button>
          </Tooltip>
        }
      </Typography>

      {afiliado?.sinFichaAfiliacion && <Grid item xs={12} style={{ marginTop: "-1.5rem" }}>
        <Paper
          style={{ paddingLeft: 0, textAlign: 'center', backgroundColor: "#FFFF00", /*paddingLeft: 25,*/ }}
          component={"div"}
          elevation={1}
        >
          <Typography
            style={{
              color: "#000000",
              fontSize: "1rem"
            }}
            variant={"subtitle1"}
            component={"p"}
          >
            SUSPENDIDO
          </Typography>
        </Paper>
      </Grid>}

      {presupuestoSeleccionado?.idEstadoPresupuesto === AUTORIZACIONES_PRESUPUESTOS_ESTADOS.PENDIENTE_CONTRATOS
        && afiliado?.fecha_baja !== null
        && <Grid item xs={12} style={{ marginTop: "-1.5rem" }}>
          <Paper
            style={{ paddingLeft: 0, textAlign: 'center', backgroundColor: "#ff1500", /*paddingLeft: 25,*/ }}
            component={"div"}
            elevation={1}
          >
            <Typography
              style={{
                color: "#000000",
                fontSize: "1rem"
              }}
              variant={"subtitle1"}
              component={"p"}
            >
              AfILIADO DE BAJA
            </Typography>
          </Paper>
        </Grid>}

      {openModalConsumos && (
        <ModalHistorialAllConsumos
          open={openModalConsumos}
          onClose={() => {
            setOpenModalConsumos(false);
          }}
          afiliado={afiliado}
        />
      )}
      <Table style={{ width: "80%", margin: "auto" }}>
        <TableBody>
          <TableRow>
            <TableCell style={{ borderBottom: "0", fontSize: "1rem" }}>
              Afiliado:
            </TableCell>
            <TableCell style={{ borderBottom: "0", fontSize: "1rem" }}>
              {afiliado?.apellido_y_nombre}
            </TableCell>
            <TableCell style={{ borderBottom: "0", fontSize: "1rem" }}>
              Cuil:
            </TableCell>
            <TableCell style={{ borderBottom: "0", fontSize: "1rem" }}>
              {afiliado?.cuil}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell style={{ borderBottom: "0", fontSize: "1rem" }}>
              Email:
            </TableCell>
            <TableCell style={{ borderBottom: "0", fontSize: "1rem" }}>
              {afiliado?.domiciliosAfiliados?.mail}
            </TableCell>
            <TableCell style={{ borderBottom: "0", fontSize: "1rem" }}>
              Seccional:
            </TableCell>
            <TableCell style={{ borderBottom: "0", fontSize: "1rem" }}>
              {afiliado?.domiciliosAfiliados?.seccional?.descripcion_seccional}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell style={{ borderBottom: "0", fontSize: "1rem" }}>
              Celular:
            </TableCell>
            <TableCell style={{ borderBottom: "0", fontSize: "1rem" }}>
              {afiliado?.domiciliosAfiliados?.celular}
            </TableCell>
            <TableCell style={{ borderBottom: "0", fontSize: "1rem" }}>
              Telefono:
            </TableCell>
            <TableCell style={{ borderBottom: "0", fontSize: "1rem" }}>
              {afiliado?.domiciliosAfiliados?.telefono}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell style={{ borderBottom: "0", fontSize: "1rem" }}>
              Fecha de Nac:
            </TableCell>
            <TableCell style={{ borderBottom: "0", fontSize: "1rem" }}>
              {new Date(
                afiliado?.fecha_nacimiento
              ).toLocaleString("es", optionsfecha)}
            </TableCell>
            <TableCell style={{ borderBottom: "0", fontSize: "1rem" }}>
              Edad:
            </TableCell>
            <TableCell style={{ borderBottom: "0", fontSize: "1rem" }}>
              {edadAfiliado} años
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
      <Grid
        style={{
          marginTop: "1rem",
          display: "flex",
          justifyContent: "space-evenly",
        }}
      >
        <FormControlLabel
          control={<Checkbox checked={afiliado?.incapacitado === 1} disabled />}
          label={
            <Typography style={{ color: "black" }}>Discapacitado</Typography>
          }
        />
        <FormControlLabel
          control={<Checkbox checked={afiliado?.judicializado === true} disabled />}
          label={
            <Typography style={{ color: "black" }}>Judicializado</Typography>
          }
        />
        {/* {solicitud &&
          <FormControlLabel
            control={
              <Checkbox
                checked={(idMotivoInternacion && idMotivoInternacion !== 4) ||
                  recuperoSolicitud.length > 0 || desdeBandejaRecupero}
                disabled
              />
            }
            label={
              <Typography style={{ color: "black" }}>Recupero</Typography>
            }
          />
        } */}
        {solicitud &&
          <FormControlLabel
            control={
              <Checkbox
                checked={ afiliadosRecupero.length > 0 || desdeBandejaRecupero}
                disabled
              />
            }
            label={
              <Typography style={{ color: "black" }}>Afiliado en Recupero</Typography>
            }
          />
        }
      </Grid>
      {empadronamientoSolicitud.length > 0 &&
        <Grid
          style={{
            display: "flex",
            marginTop: 10,
          }}
        >
          <Typography
            variant="h5"
            style={{
              margin: "10px 0 0 100px",
              textAlign: "center",
              fontWeight: "bold",
              fontSize: 20,
            }}
          >
            Empadronamientos:
          </Typography>
          {empadronamientoSolicitud.map((item) =>
            <FormControlLabel
              control={<Checkbox checked={true} disabled />}
              style={{ marginLeft: 40 }}
              label={
                <Typography style={{ color: "black" }}>{item.descripcion}</Typography>
              }
            />
          )}
        </Grid>
      }
      {(integracion || afiliado?.incapacitado === 1) &&
        <Grid container>
          <Grid item xs={12} style={{ marginTop: "1rem" }}>
            <CarritoCertificados
              gestion={true}
              itemsCertificados={itemsCertificados}
              certificadoVigente={certificadoVigente}
              setCertificadoVigente={setCertificadoVigente}
              idTipoCertificado={TIPO_CERTIFICADOS.DISCAPACIDAD}
              afiliadoAut={afiliado}
            />
          </Grid>
        </Grid>
      }
    </React.Fragment>
  );
};
